<div class="parser-settings">
  <lib-pdf-ai-parser-nav></lib-pdf-ai-parser-nav>

  <div class="settings-header">
    <h3>{{ 'AI_PARSER_SETTINGS_TITLE' | translate }}</h3>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage | translate }}</div>

  <div *ngIf="loading" class="settings-panel">
    <div class="settings-row" *ngFor="let placeholder of [1, 2]">
      <div class="settings-row-text">
        <span class="skeleton skeleton-label"></span>
        <span class="skeleton skeleton-help"></span>
      </div>
      <span class="skeleton skeleton-switch"></span>
    </div>
  </div>

  <form *ngIf="settings && !loading" class="settings-form" (ngSubmit)="save()">
    <fieldset class="settings-panel" [disabled]="saving">
      <h4 class="settings-section">{{ 'AI_PARSER_SETTINGS_SECTION_REVIEW' | translate }}</h4>
      <div class="settings-row">
        <label class="settings-row-text" for="allowInvalidRowOverride">
          <span class="settings-row-label">{{ 'AI_PARSER_SETTINGS_ALLOW_OVERRIDE_LABEL' | translate }}</span>
          <span class="settings-row-help">{{ 'AI_PARSER_SETTINGS_ALLOW_OVERRIDE_HELP' | translate }}</span>
        </label>
        <input
          class="settings-switch"
          type="checkbox"
          role="switch"
          id="allowInvalidRowOverride"
          name="allowInvalidRowOverride"
          [(ngModel)]="settings.allowInvalidRowOverride"
        />
      </div>

      <div class="settings-row">
        <label class="settings-row-text" for="checkAvailability">
          <span class="settings-row-label">{{ 'AI_PARSER_SETTINGS_CHECK_AVAILABILITY_LABEL' | translate }}</span>
          <span class="settings-row-help">{{ 'AI_PARSER_SETTINGS_CHECK_AVAILABILITY_HELP' | translate }}</span>
        </label>
        <input
          class="settings-switch"
          type="checkbox"
          role="switch"
          id="checkAvailability"
          name="checkAvailability"
          [(ngModel)]="settings.checkAvailability"
        />
      </div>

      <div class="settings-row">
        <label class="settings-row-text" for="pickStockCoveringMostRows">
          <span class="settings-row-label">{{ 'AI_PARSER_SETTINGS_PICK_STOCK_COVERING_ROWS_LABEL' | translate }}</span>
          <span class="settings-row-help">{{ 'AI_PARSER_SETTINGS_PICK_STOCK_COVERING_ROWS_HELP' | translate }}</span>
        </label>
        <input
          class="settings-switch"
          type="checkbox"
          role="switch"
          id="pickStockCoveringMostRows"
          name="pickStockCoveringMostRows"
          [(ngModel)]="settings.pickStockCoveringMostRows"
        />
      </div>

      <div class="settings-row">
        <label class="settings-row-text" for="manualReviewThreshold">
          <span class="settings-row-label">{{ 'AI_PARSER_SETTINGS_MANUAL_REVIEW_THRESHOLD_LABEL' | translate }}</span>
          <span class="settings-row-help">{{ 'AI_PARSER_SETTINGS_MANUAL_REVIEW_THRESHOLD_HELP' | translate }}</span>
          <span *ngIf="thresholdInvalid" class="invalid-feedback d-block">{{ 'AI_PARSER_SETTINGS_THRESHOLD_INVALID' | translate }}</span>
        </label>
        <input
          class="settings-number"
          type="number"
          min="1"
          step="1"
          id="manualReviewThreshold"
          name="manualReviewThreshold"
          [class.is-invalid]="thresholdInvalid"
          [(ngModel)]="settings.manualReviewThreshold"
        />
      </div>

      <div class="settings-row">
        <label class="settings-row-text" for="defaultFlowId">
          <span class="settings-row-label">{{ 'AI_PARSER_SETTINGS_DEFAULT_FLOW_LABEL' | translate }}</span>
          <span class="settings-row-help">{{ 'AI_PARSER_SETTINGS_DEFAULT_FLOW_HELP' | translate }}</span>
        </label>
        <select class="settings-select" id="defaultFlowId" name="defaultFlowId" [(ngModel)]="settings.defaultFlowId">
          <option [ngValue]="null">{{ 'AI_PARSER_NO_FLOW' | translate }}</option>
          <option *ngFor="let flow of flows" [ngValue]="flow.id">{{ flow.name || flow.id }}</option>
        </select>
      </div>

      <h4 class="settings-section">{{ 'AI_PARSER_SETTINGS_SECTION_AUTOMATION' | translate }}</h4>
      <div class="settings-row">
        <label class="settings-row-text" for="autoSubmitEnabled">
          <span class="settings-row-label">{{ 'AI_PARSER_SETTINGS_AUTO_SUBMIT_LABEL' | translate }}</span>
          <span class="settings-row-help">{{ 'AI_PARSER_SETTINGS_AUTO_SUBMIT_HELP' | translate }}</span>
        </label>
        <input
          class="settings-switch"
          type="checkbox"
          role="switch"
          id="autoSubmitEnabled"
          name="autoSubmitEnabled"
          [(ngModel)]="settings.autoSubmitEnabled"
        />
      </div>

      <h4 class="settings-section">{{ 'AI_PARSER_SETTINGS_SECTION_INTAKE' | translate }}</h4>
      <div class="settings-row settings-row-stacked">
        <div class="settings-row-text">
          <span class="settings-row-label">{{ 'AI_PARSER_SETTINGS_TRUSTED_FORWARDERS_LABEL' | translate }}</span>
          <span class="settings-row-help">{{ 'AI_PARSER_SETTINGS_TRUSTED_FORWARDERS_HELP' | translate }}</span>
        </div>
        <div class="forwarder-chips" *ngIf="settings.trustedForwarders.length">
          <span class="forwarder-chip" *ngFor="let forwarder of settings.trustedForwarders">
            {{ forwarder }}
            <button
              type="button"
              class="chip-remove"
              (click)="removeForwarder(forwarder)"
              [attr.aria-label]="'DELETE' | translate"
            >
              <i class="fas fa-times"></i>
            </button>
          </span>
        </div>
        <div class="forwarder-add">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newForwarder"
            name="newForwarder"
            [placeholder]="'AI_PARSER_SETTINGS_TRUSTED_FORWARDERS_PLACEHOLDER' | translate"
            (keydown.enter)="$event.preventDefault(); addForwarder()"
            autocomplete="off"
          />
          <button type="button" class="btn btn-link text-button" (click)="addForwarder()">
            <i class="fal fa-plus"></i> {{ 'ADD' | translate }}
          </button>
        </div>
      </div>

      <div class="settings-row settings-row-stacked">
        <div class="settings-row-text">
          <span class="settings-row-label">{{ 'AI_PARSER_SETTINGS_NOTIFICATION_RECIPIENTS_LABEL' | translate }}</span>
          <span class="settings-row-help">{{ 'AI_PARSER_SETTINGS_NOTIFICATION_RECIPIENTS_HELP' | translate }}</span>
        </div>
        <div class="forwarder-chips" *ngIf="settings.notificationRecipients.length">
          <span class="forwarder-chip" *ngFor="let recipient of settings.notificationRecipients">
            {{ recipient }}
            <button
              type="button"
              class="chip-remove"
              (click)="removeRecipient(recipient)"
              [attr.aria-label]="'DELETE' | translate"
            >
              <i class="fas fa-times"></i>
            </button>
          </span>
        </div>
        <div class="forwarder-add">
          <input
            type="email"
            class="form-control"
            [class.is-invalid]="recipientInvalid"
            [(ngModel)]="newRecipient"
            name="newRecipient"
            [placeholder]="'AI_PARSER_SETTINGS_NOTIFICATION_RECIPIENTS_PLACEHOLDER' | translate"
            (keydown.enter)="$event.preventDefault(); addRecipient()"
            (ngModelChange)="recipientInvalid = false"
            autocomplete="off"
          />
          <button type="button" class="btn btn-link text-button" (click)="addRecipient()">
            <i class="fal fa-plus"></i> {{ 'ADD' | translate }}
          </button>
        </div>
        <div *ngIf="recipientInvalid" class="text-danger small">
          {{ 'AI_PARSER_SETTINGS_NOTIFICATION_RECIPIENTS_INVALID' | translate }}
        </div>
      </div>
    </fieldset>

    <button type="submit" class="btn btn-primary settings-save" [disabled]="saving || thresholdInvalid">
      <span *ngIf="saving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {{ 'SAVE' | translate }}
    </button>
  </form>
</div>
